import { useMutation } from '@tanstack/react-query';
import { repo } from 'index';

export const useCreateLicensePlate = () => {
  const { mutateAsync, status, isLoading } = useMutation({
    mutationFn: repo.createLicensePlate,
  });

  return {
    createLicensePlateMutateAsync: mutateAsync,
    createLicensePlateStatus: status,
    isCreateLicensePlateLoading: isLoading,
  };
};
